import { z } from 'zod';
import { IPAndRequiredPortListSchema } from '#schemas/general/ip-address-and-required-port.ts';
import { reformatCommaList } from './helpers/list.ts';

export const lighthouseAdvertiseAddrsSchema = z.string().transform(reformatCommaList).pipe(IPAndRequiredPortListSchema);

export const lighthouseAdvertiseAddrsRequiredSchema = z
  .string()
  .transform(reformatCommaList)
  .pipe(IPAndRequiredPortListSchema)
  .refine((val) => val.length !== 0, { message: 'Enter a comma-separated list of ip:port addresses' });
